var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.individualCheck
        ? _c("validation-observer", {
            ref: "formIndividual",
            on: { change: _vm.submitForm },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var invalid = ref.invalid
                    return [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.addLeadsIndividual($event)
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: _vm.isEdit ? 10 : 12 } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Lead Source",
                                      vid: "Lead Source",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Lead Source",
                                                    "label-for": "h-First",
                                                  },
                                                },
                                                [
                                                  _c("b-form-select", {
                                                    attrs: {
                                                      options:
                                                        _vm.sourceOptions,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.profiledetails
                                                          .source
                                                          .leadClientDetailId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.profiledetails
                                                            .source,
                                                          "leadClientDetailId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "profiledetails.source.leadClientDetailId",
                                                    },
                                                  }),
                                                  errors.length
                                                    ? _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm.isEdit
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "w-100",
                                          attrs: { variant: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal("SOURCE")
                                            },
                                          },
                                        },
                                        [_vm._v(" Add Source ")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Sales Person",
                                        "label-for": "h-First",
                                      },
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "Sales Person",
                                          vid: "Sales Person",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-select", {
                                                    attrs: {
                                                      options:
                                                        _vm.optionsSalesPerson,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.leadId
                                                          .salesPersonId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.leadId,
                                                          "salesPersonId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "leadId.salesPersonId",
                                                    },
                                                  }),
                                                  errors.length
                                                    ? _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "First Name",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "First Name",
                                                    "label-for": "h-firstName",
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "firstName",
                                                      placeholder: "First Name",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.leadId.otherName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.leadId,
                                                          "otherName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "leadId.otherName",
                                                    },
                                                  }),
                                                  errors.length
                                                    ? _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "required",
                                      name: "Last Name",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Last Name",
                                                    "label-for": "h-lastName",
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "lastName",
                                                      placeholder: "Last Name",
                                                    },
                                                    model: {
                                                      value: _vm.leadId.surname,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.leadId,
                                                          "surname",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "leadId.surname",
                                                    },
                                                  }),
                                                  errors.length
                                                    ? _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: "email_regex",
                                      name: "Email",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var errors = ref.errors
                                            return [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    label: "Email",
                                                    "label-for": "d-email",
                                                  },
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "d-email",
                                                      type: "email",
                                                      placeholder:
                                                        "Enter your email (e.g., example@domain.com)",
                                                    },
                                                    model: {
                                                      value: _vm.leadId.email,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.leadId,
                                                          "email",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "leadId.email",
                                                    },
                                                  }),
                                                  errors.length
                                                    ? _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Date of Birth",
                                        "label-for": "dob",
                                      },
                                    },
                                    [
                                      _c("flat-pickr", {
                                        staticClass: "form-control",
                                        attrs: { config: _vm.config },
                                        model: {
                                          value: _vm.leadId.dob,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.leadId, "dob", $$v)
                                          },
                                          expression: "leadId.dob",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Address",
                                        "label-for": "h-Address",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "h-Address",
                                          placeholder: "Address",
                                        },
                                        model: {
                                          value: _vm.leadId.addressLine1,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.leadId,
                                              "addressLine1",
                                              $$v
                                            )
                                          },
                                          expression: "leadId.addressLine1",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Street Name",
                                        "label-for": "h-Street",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "h-Street",
                                          placeholder: "Street Name",
                                        },
                                        model: {
                                          value: _vm.leadId.addressLine2,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.leadId,
                                              "addressLine2",
                                              $$v
                                            )
                                          },
                                          expression: "leadId.addressLine2",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "10" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "City",
                                        "label-for": "h-City",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: { options: _vm.cityOptions },
                                        model: {
                                          value:
                                            _vm.profiledetails.city
                                              .leadClientDetailId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.profiledetails.city,
                                              "leadClientDetailId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "profiledetails.city.leadClientDetailId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.isEdit
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "w-100",
                                          attrs: { variant: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal("CITY")
                                            },
                                          },
                                        },
                                        [_vm._v(" Add City ")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Tel ",
                                        "label-for": "h-tel",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "h-tel",
                                          placeholder: "Tel",
                                          onkeydown:
                                            "javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'",
                                        },
                                        model: {
                                          value: _vm.leadId.tel,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.leadId, "tel", $$v)
                                          },
                                          expression: "leadId.tel",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Category",
                                        "label-for": "h-specialInstructions",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "h-specialInstructions",
                                          placeholder: "Category",
                                        },
                                        model: {
                                          value: _vm.leadId.fieldInstruction,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.leadId,
                                              "fieldInstruction",
                                              $$v
                                            )
                                          },
                                          expression: "leadId.fieldInstruction",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: _vm.isEdit ? 10 : 12 } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Job Title",
                                        "label-for": "h-title",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: { options: _vm.jobTitleOptions },
                                        model: {
                                          value:
                                            _vm.profiledetails.jobTitle
                                              .leadClientDetailId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.profiledetails.jobTitle,
                                              "leadClientDetailId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "profiledetails.jobTitle.leadClientDetailId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.isEdit
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "w-100",
                                          attrs: { variant: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal("JOBTITLE")
                                            },
                                          },
                                        },
                                        [_vm._v(" Add Job Title ")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-col",
                                { attrs: { cols: _vm.isEdit ? 10 : 12 } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Hobbies",
                                        "label-for": "h-title",
                                      },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          multiple: "",
                                          placeholder: "Add Hobbies",
                                          label: "itemTitle",
                                          options: _vm.hobbiesOptions,
                                        },
                                        model: {
                                          value: _vm.selectedHobbies,
                                          callback: function ($$v) {
                                            _vm.selectedHobbies = $$v
                                          },
                                          expression: "selectedHobbies",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.isEdit
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "w-100",
                                          attrs: { variant: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal("HOBBIE")
                                            },
                                          },
                                        },
                                        [_vm._v(" Add Hobby ")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-col",
                                { attrs: { cols: _vm.isEdit ? 10 : 12 } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Products interested in",
                                        "label-for": "h-title",
                                      },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          multiple: "",
                                          placeholder:
                                            "Add Products Interested in",
                                          label: "itemTitle",
                                          options: _vm.productInterestOptions,
                                        },
                                        model: {
                                          value: _vm.ProductInterestSelected,
                                          callback: function ($$v) {
                                            _vm.ProductInterestSelected = $$v
                                          },
                                          expression: "ProductInterestSelected",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.isEdit
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "w-100",
                                          attrs: { variant: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModal(
                                                "PRODUCTINTEREST"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Add Product Interest ")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Marketing Segment",
                                        "label-for": "h-title",
                                      },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          multiple: "",
                                          placeholder: "Add Marketing Segments",
                                          label: "itemTitle",
                                          options: _vm.segmentOptions,
                                        },
                                        model: {
                                          value: _vm.selectedSegments,
                                          callback: function ($$v) {
                                            _vm.selectedSegments = $$v
                                          },
                                          expression: "selectedSegments",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Percentage",
                                        "label-for": "d-percentage",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "d-percentage",
                                              type: "number",
                                              placeholder: "Percentage",
                                            },
                                            model: {
                                              value: _vm.leadId.percentage,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.leadId,
                                                  "percentage",
                                                  $$v
                                                )
                                              },
                                              expression: "leadId.percentage",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                },
                                                [_vm._v("%")]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { staticClass: "12" },
                                [
                                  _c("CustomFieldsDetails", {
                                    attrs: {
                                      AdditionalFields:
                                        _vm.leadId.additionalFields,
                                      ModuleReference: "LeadClient",
                                    },
                                    on: {
                                      onchange: _vm.additionalFieldChanges,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      staticClass: "mr-1",
                                      attrs: {
                                        type: "button",
                                        variant: "primary",
                                      },
                                      on: { click: _vm.addLeadsIndividual },
                                    },
                                    [
                                      _vm.loading
                                        ? _c("b-spinner", {
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                      _vm._v(" Submit "),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(186, 191, 199, 0.15)",
                                          expression:
                                            "'rgba(186, 191, 199, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "outline-secondary" },
                                      on: { click: _vm.resetForm },
                                    },
                                    [_vm._v(" Reset ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1288279772
            ),
          })
        : _vm._e(),
      !_vm.individualCheck
        ? _c(
            "validation-observer",
            { ref: "formCompany", on: { change: _vm.submitForm } },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.addLeadsCompany($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "10" } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Lead Source",
                              vid: "Lead Source",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Lead Source",
                                            "label-for": "h-First",
                                          },
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              options: _vm.sourceOptions,
                                            },
                                            model: {
                                              value:
                                                _vm.profiledetails.source
                                                  .leadClientDetailId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.profiledetails.source,
                                                  "leadClientDetailId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "profiledetails.source.leadClientDetailId",
                                            },
                                          }),
                                          errors.length
                                            ? _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3169966782
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { cols: "2" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showModal("SOURCE")
                                },
                              },
                            },
                            [_vm._v(" Add Source ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Sales Person",
                                "label-for": "h-First",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: "Sales Person",
                                  vid: "Sales Person",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-select", {
                                            attrs: {
                                              options: _vm.optionsSalesPerson,
                                            },
                                            model: {
                                              value: _vm.leadId.salesPersonId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.leadId,
                                                  "salesPersonId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "leadId.salesPersonId",
                                            },
                                          }),
                                          errors.length
                                            ? _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  613270687
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Company Name",
                                "label-for": "h-company",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: "Company Name",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "h-full",
                                              placeholder: "Name",
                                            },
                                            model: {
                                              value: _vm.leadId.otherName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.leadId,
                                                  "otherName",
                                                  $$v
                                                )
                                              },
                                              expression: "leadId.otherName",
                                            },
                                          }),
                                          errors.length
                                            ? _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1189699494
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "email_regex", name: "Email" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var errors = ref.errors
                                    return [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Email",
                                            "label-for": "d-email",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id: "d-email",
                                              type: "email",
                                              placeholder:
                                                "Enter your email (e.g., example@domain.com)",
                                            },
                                            model: {
                                              value: _vm.leadId.email,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.leadId,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "leadId.email",
                                            },
                                          }),
                                          errors.length
                                            ? _c(
                                                "small",
                                                { staticClass: "text-danger" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1527751334
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Address",
                                "label-for": "h-Address",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Address",
                                  placeholder: "Address",
                                },
                                model: {
                                  value: _vm.leadId.addressLine1,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.leadId, "addressLine1", $$v)
                                  },
                                  expression: "leadId.addressLine1",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Street Name",
                                "label-for": "h-Street",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Street",
                                  placeholder: "Street Name",
                                },
                                model: {
                                  value: _vm.leadId.addressLine2,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.leadId, "addressLine2", $$v)
                                  },
                                  expression: "leadId.addressLine2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "City", "label-for": "h-City" } },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.cityOptions },
                                model: {
                                  value:
                                    _vm.profiledetails.city.leadClientDetailId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.profiledetails.city,
                                      "leadClientDetailId",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "profiledetails.city.leadClientDetailId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { cols: "2" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showModal("CITY")
                                },
                              },
                            },
                            [_vm._v(" Add City ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Company Tel",
                                "label-for": "h-tel",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-tel",
                                  placeholder: "Company Tel",
                                  type: "number",
                                  onkeydown:
                                    "javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'",
                                },
                                model: {
                                  value: _vm.leadId.tel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.leadId, "tel", $$v)
                                  },
                                  expression: "leadId.tel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Category",
                                "label-for": "h-specialInstructions",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-specialInstructions",
                                  placeholder: "Category",
                                },
                                model: {
                                  value: _vm.leadId.fieldInstruction,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.leadId,
                                      "fieldInstruction",
                                      $$v
                                    )
                                  },
                                  expression: "leadId.fieldInstruction",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Website",
                                "label-for": "h-Website",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Website",
                                  placeholder: "Website",
                                },
                                model: {
                                  value: _vm.leadId.website,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.leadId, "website", $$v)
                                  },
                                  expression: "leadId.website",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Company BRN",
                                "label-for": "h-Number",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "h-Number",
                                  placeholder: "Individual BRN",
                                },
                                model: {
                                  value: _vm.leadId.brn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.leadId, "brn", $$v)
                                  },
                                  expression: "leadId.brn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "10" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Products interested in",
                                "label-for": "h-title",
                              },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  multiple: "",
                                  placeholder: "Add Products Interested in",
                                  label: "itemTitle",
                                  options: _vm.productInterestOptions,
                                },
                                model: {
                                  value: _vm.ProductInterestSelected,
                                  callback: function ($$v) {
                                    _vm.ProductInterestSelected = $$v
                                  },
                                  expression: "ProductInterestSelected",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex align-items-center",
                          attrs: { cols: "2" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.showModal("PRODUCTINTEREST")
                                },
                              },
                            },
                            [_vm._v(" Add Product Interest ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Marketing Segment",
                                "label-for": "h-title",
                              },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  multiple: "",
                                  placeholder: "Add Marketing Segments",
                                  label: "itemTitle",
                                  options: _vm.segmentOptions,
                                },
                                model: {
                                  value: _vm.selectedSegments,
                                  callback: function ($$v) {
                                    _vm.selectedSegments = $$v
                                  },
                                  expression: "selectedSegments",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Percentage",
                                "label-for": "h-percentage",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group" },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "h-percentage",
                                      type: "number",
                                      placeholder: "Percentage",
                                    },
                                    model: {
                                      value: _vm.leadId.percentage,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.leadId, "percentage", $$v)
                                      },
                                      expression: "leadId.percentage",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "input-group-text" },
                                        [_vm._v("%")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("CustomFieldsDetails", {
                            attrs: {
                              AdditionalFields: _vm.leadId.additionalFields,
                              ModuleReference: "LeadClient",
                            },
                            on: { onchange: _vm.additionalFieldChanges },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(255, 255, 255, 0.15)",
                                  expression: "'rgba(255, 255, 255, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              staticClass: "mr-1",
                              attrs: { type: "button", variant: "primary" },
                              on: { click: _vm.addLeadsCompany },
                            },
                            [_vm._v(" Submit ")]
                          ),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "ripple",
                                  rawName: "v-ripple.400",
                                  value: "rgba(186, 191, 199, 0.15)",
                                  expression: "'rgba(186, 191, 199, 0.15)'",
                                  modifiers: { 400: true },
                                },
                              ],
                              attrs: { variant: "outline-secondary" },
                              on: { click: _vm.resetForm },
                            },
                            [_vm._v(" Reset ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: { id: _vm.modalId, title: _vm.modalTitle, "hide-footer": "" },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addItem($event)
                },
              },
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "" + this.modalTitle,
                    "label-for": "input-new-item",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "input-new-item",
                      required: "",
                      placeholder: "Enter new item",
                    },
                    model: {
                      value: _vm.newItem,
                      callback: function ($$v) {
                        _vm.newItem = $$v
                      },
                      expression: "newItem",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-button",
                { attrs: { type: "submit", variant: "primary" } },
                [_vm._v("Add")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "p-1",
              staticStyle: { "max-height": "500px", "overflow-y": "auto" },
            },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  items: _vm.modalOptions,
                  responsive: "",
                  fields: _vm.fields,
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(name)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.modalType === "PRODUCTINTEREST" || "HOBBIE"
                                ? data.item.itemTitle
                                : data.item.text
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _vm.HasPermission(_vm.PermissionList.Sales_Delete)
                          ? _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "danger" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(data.item.value)
                                  },
                                },
                              },
                              [_vm._v("Delete")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }